import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrows",
  "use": "arrows-usage",
  "viewBox": "0 0 220.682 220.682",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 220.682 220.682\" id=\"arrows\">\n<g>\n\t<polygon points=\"110.341,0 10.639,99.703 38.924,127.986 110.341,56.568 181.758,127.986 210.043,99.703\" />\n\t<polygon points=\"110.341,92.695 10.639,192.396 38.924,220.682 110.341,149.264 181.758,220.682 210.043,192.396\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol